module.exports = __webpack_public_path__ + "img/1403year.3fcfd78f.png";